module.exports = __webpack_public_path__ + "static/media/Screenshot_59.8bbbc230.png";